import { configureStore } from "@reduxjs/toolkit";
import aunthSlice from "./reducers/aunthSlice";
import menuSlice from "./reducers/menuSlice";
import searchSlice from "./reducers/searchSlice";
import themeSlice from "./reducers/themeSlice";

export const store = configureStore({
  reducer: {
    theme: themeSlice,
    aunth: aunthSlice,
    menu: menuSlice,
    search: searchSlice,
  },
});
